import { ChangeDetectionStrategy, Component, HostListener, model, OnDestroy } from '@angular/core';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppRoutes } from '@shared/enums';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { AppNavigationComponent } from '@layout/components/app-navigation/app-navigation.component';
import { TrapFocusDirective } from '@shared/directives/trap-focus.directive';
import { SidebarCustomComponent } from '@shared/components/sidebar/sidebar.component';
import { DecoIconComponent } from '@shared/components/deco-icon/deco-icon.component';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
        ButtonDirective,
        SidebarCustomComponent,
        AppNavigationComponent,
        TrapFocusDirective,
        RouterLink,
        DecoIconComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent implements OnDestroy {
    isSidebarVisible = model<boolean>(false);
    routerSubscription!: Subscription;

    readonly appRoutes = AppRoutes;

    constructor(private router: Router) {}

    @HostListener('window:resize', ['$event.target.innerWidth'])
    onScreenResize(width: number) {
        if (width <= 990) {
            this.routerSubscription = this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationStart && this.isSidebarVisible) {
                    this.isSidebarVisible.set(false);
                }
            });
        }

        if (width > 991) {
            this.isSidebarVisible.set(false);
            this.routerSubscription?.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
    }
}
